export default __webpack_public_path__ + "static/media/features-5.ccf7d111.jpg";